import { message } from "antd";
import { FormikProps } from "formik";
import React, { FC, useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router";
import { data } from "../../../constants";
import { clearErrors } from "../../../redux/auth/actions";
import { Login } from "../../templates/Login";
import { Props } from "./types";

const LoginPage: FC<Props> = props => {
  const {
    isLoading,
    login,
    isAuthenticated,
    user,
    request,
    serverError
  } = props;
  const history = useHistory();
  const dispatch = useDispatch();
  const onForgotPassword = () => {
    return history.push("/forgot-password");
  };

  const formRef = useRef<FormikProps<any>>(null);

  useEffect(() => {
    if (isAuthenticated && !isLoading && user) {
      user && user.accessType === "interviewer"
        ? history.push("/recruit/initial-interview")
        : history.push("/recruit/new-applicants");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const loginErrorMessages = data.loginErrorMessages;

    if (serverError?.includes('user-not-found') || serverError?.includes('wrong-password')) {
      formRef.current?.setFieldError(
        "email",
        "Incorrect email address or password"
      );
      formRef.current?.setFieldError(
        "password",
        "Incorrect email address or password"
      );
    }

    if (serverError === loginErrorMessages.suspendedAccount) {
      message.config({ duration: 2, maxCount: 1 });
      message.error(loginErrorMessages.suspendedAccount);
    }

    if (serverError === loginErrorMessages.frequentFailedLogins) {
      message.config({ duration: 2, maxCount: 1 });
      message.error(
        "Access to this account has been temporarily disabled due to many failed login attempts."
      );
    }
    return () => {
      dispatch(clearErrors());
    };
  }, [dispatch, serverError]);

  const onLogin = async (email: string, password: string) => {
    await login(email, password);
  };

  return (
    <Login
      isLoading={isLoading || request?.isLoading}
      onForgotPassword={onForgotPassword}
      onLogin={onLogin}
      innerRef={formRef}
    />
  );
};

export default LoginPage;
